<rx-intuitive-teeth-diagram-layout>
	<rx-intuitive-teeth-diagram
		rx-intuitive-teeth-diagram-diagram
		[upperJaw]="(upperJaw$ | async) ?? []"
		[lowerJaw]="(lowerJaw$ | async) ?? []"
		[chartReadOnly]="!!(isTeethDiagramReadOnly$ | async)"
		(toothClicked)="onToothClicked($event)"
		(resetSelectedRequested)="onResetSelectedRequested()"
	/>

	<div rx-intuitive-teeth-diagram-banner>
		<rx-intuitive-bridge-banner
			*ngIf="showGuidanceBanner$ | async"
			(closeEvent)="onBannerClosed($event)"
		></rx-intuitive-bridge-banner>
		<tlk-banner type="error" *ngIf="validationErrorSummary$ | async as errorKey">
			<div tlkBannerBody class="rx-intuitive-bridge-error-banner__message">
				{{ errorKey | translate }}
			</div>
		</tlk-banner>
	</div>

	<rx-intuitive-bridge-indication-buttons
		rx-intuitive-teeth-diagram-buttons
		[indicationIds]="(indications$ | async) ?? []"
		[enabledIndicationIds]="(enabledIndications$ | async) ?? []"
		[selectedIndicationIds]="(selectedTeethIndicationIds$ | async) ?? []"
		[disabled]="(indicationsDisabled$ | async) ?? true"
		[canRemove]="(canRemoveSelectedTooth$ | async) ?? false"
		(indicationSelected)="onIndicationSelected($event)"
		(removeFromBridge)="onRemoveToothFromBridge()"
	/>

	<div rx-intuitive-teeth-diagram-panel>
		<rx-intuitive-bridge-editor
			[hasUnsavedChanges]="(hasUnsavedChanges$ | async) ?? false"
			[teeth]="(bridgeEditorTeeth$ | async) ?? []"
			[canEdit]="(canEditBridgeEditor$ | async) ?? false"
			[canDelete]="(isTeethDiagramReadOnly$ | async) === false"
			[bridgeTeethFlat]="(bridgeTeethFlat$ | async) ?? []"
			[ponticDesigns]="(ponticDesigns$ | async) ?? []"
			[bridgeListItem]="bridgeListItem$ | async"
			(crownFormChanged)="onBridgeCrownFormChanged($event)"
			(additionalInfoApplied)="onBridgeAdditionalInfoApplied($event)"
			(clearDisabledFields)="onBridgeClearDisabledFields($event)"
			(ponticDesignChanged)="onPonticDesignChanged($event)"
			(delete)="onDeleteBridge()"
		/>
	</div>

	<rx-intuitive-bridge-diagram-footer
		rx-intuitive-teeth-diagram-footer
		[hasUnsavedChanges]="(hasUnsavedChanges$ | async) ?? false"
		[isReadOnly]="(isTeethDiagramReadOnly$ | async) ?? false"
		(save)="onSaveBridge()"
		(revert)="onRevertChanges()"
		(closed)="onCloseBridge()"
	/>

</rx-intuitive-teeth-diagram-layout>
